import { isSameDay } from 'date-fns';
import { isAfterDay } from './date.mjs';

function isDayRangeCollapsed(start, end) {
  if (isSameDay(start, end)) {
    return false;
  }
  return isAfterDay(start, end);
}

export { isDayRangeCollapsed };
//# sourceMappingURL=range.mjs.map
